import { render, staticRenderFns } from "./Documento.vue?vue&type=template&id=10d205fb&scoped=true"
import script from "./Documento.vue?vue&type=script&lang=js"
export * from "./Documento.vue?vue&type=script&lang=js"
import style0 from "./Documento.vue?vue&type=style&index=0&id=10d205fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d205fb",
  null
  
)

export default component.exports